export default {
    path : "officebuilding-item-allsuccess",
    name : "officebuilding-item-allsuccess",
    meta : {
        title : "关注项目"
    },
    component: () => import('@/pages/officebuilding/allsuccess/Index'),
    redirect: {
        name : "officebuilding-item-allsuccess-whole"
    },
    children: [
        {
            path: 'all',
            name: 'officebuilding-item-allsuccess-whole',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'officebuilding-item-allsuccess-recent',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'officebuilding-item-allsuccess-atme',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'officebuilding-item-allsuccess-meat',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'officebuilding-item-allsuccess-reply',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'officebuilding-item-allsuccess-search',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/officebuilding/allsuccessitem/index.js